import { auth } from '../firebase';

export const getStoragePathFromUrl = (url) => {
  if (!url) return '';

  try {
    const parsedUrl = new URL(url);
    const marker = '/o/';
    const markerIndex = parsedUrl.pathname.indexOf(marker);
    if (markerIndex === -1) return '';
    return decodeURIComponent(parsedUrl.pathname.slice(markerIndex + marker.length));
  } catch {
    return '';
  }
};

export const getProtectedFileUrl = async ({ path, moduleId, resourceId }) => {
  if (!auth.currentUser) {
    throw new Error('You must be signed in to open this file.');
  }

  const idToken = await auth.currentUser.getIdToken();
  const response = await fetch('/api/lms-file-access', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ path, moduleId, resourceId })
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || 'Unable to open this file.');
  }

  const result = await response.json();
  return result.url;
};
